import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from '../config/axios';

const ProtectedRoute = ({ children, user }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const validateToken = async () => {
      const token = localStorage.getItem('token');
      
        // If no token or user, redirect immediately
      if (!token || !user) {
        setIsValid(false);
        setIsValidating(false);
        return;
      }

      try {
          // CRITICAL: Verify user exists in database by fetching profile
          const response = await axios.get('/users/profile');

          // If we get here, user exists in database
          if (response.data && response.data._id) {
              setIsValid(true);
        } else {
            throw new Error('User not found in database');
        }
      } catch (error) {
          console.error('❌ Token validation failed - User does not exist in database:', error);

          // Clear all authentication data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.clear();

        setIsValid(false);

          // Force redirect to login
          window.location.href = '/auth/login';
      } finally {
        setIsValidating(false);
      }
    };

    validateToken();
  }, [user]);

  if (isValidating) {
    return (
      <div className="loading">
        <div className="spinner"></div>
            <p>Validating session...</p>
      </div>
    );
  }

  if (!isValid) {
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
